import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { BubbleSizeMode } from 'store/reducers/visualisations/types';

export const elementTypeOptions: SettingsRadioItem<BubbleSizeMode>[] = [
  { value: 'default', label: 'Базовый' },
  { value: 'byIndicator', label: 'Показатель' },
];
